<style lang="css">
  @import '../../assets/css/home.css';
  .ivu-carousel-dots li button.radius {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
  .ivu-carousel-dots li.ivu-carousel-active>button.radius {
    width: 20px;
    height: 20px;
  }
  .ivu-carousel-dots-inside {
    display: block;
    position: absolute;
    bottom: 145px;
}
.ivu-carousel-dots li {
    position: relative;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    margin: 0 2px;
    padding: 7px 3px;
    cursor: pointer;
}
</style>

<template>
  <div>
      <Carousel v-model="value1" arrow="always" radius-dot>
        <CarouselItem>
          <div class="first-content">
              <img src="../../assets/imgs/首页2.jpg"/>
              <div class="first-text">
                <h3>程序化销售产品</h3>
                <p>CRM、DSP、SSP、ADX、DMP</p>

                <p class="p-t-20">
                  <Button type="warning" shape="circle" @click="showModalMessage">了解更多</Button>
                </p>
              </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="first-content">
            <img src="../../assets/imgs/首页1.jpg"/>
            <div class="first-text">
              <h3>智能化履约产品</h3>
              <p>MSP、JIT、PLM、RDD</p>
              <p class="p-t-20">
                <Button type="warning" shape="circle" @click="showModalMessage">了解更多</Button>
              </p>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="first-content">
            <img src="../../assets/imgs/首页3.jpg"/>
            <div class="first-text">
                <h3>在线化资产管理产品</h3>
                <p>IOT、EEP</p>
                <p class="p-t-20">
                  <Button type="warning" shape="circle" @click="showModalMessage">了解更多</Button>
                </p>
              </div>
          </div>
        </CarouselItem>
      </Carousel>

      <div style="position: absolute;top: 500px;"><a name="second"></a></div>
      <Carousel v-model="value2" style="margin-top: -80px;" arrow="always" dots="outside">
        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="22" :lg="12">
              <img v-show="carouseImg1" src="../../assets/platform/交易台1.png"/>
              <img v-show="!carouseImg1" src="../../assets/platform/交易台.png"/>
              <ul class="ivu-carousel-dots ivu-carousel-dots-inside">
                <li :class="carouseImg1? 'ivu-carousel-active':''" style="">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-right: 5px;" @click="carouseImg1=true"></button>
                </li>
                <li :class="carouseImg1? '':'ivu-carousel-active'">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-left: 5px;" @click="carouseImg1=false"></button>
                </li>
              </ul>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class=" text-16">
              <h3 class="p-t-20">交易台</h3>
              <p class="p-t-10">描述：对接媒介库存和投放需求，为广告主提供标准化的媒体方案，交易合同等购买决策依据，管理售后服务要求</p>
              <p class="p-t-5">功能：客户报备、行业分析、方案制定、合同制作、受众分析、流量预估、目标定向、品牌保护、服务管理、上刊设置等</p>
              <p class="p-t-5">权限：媒体销售人员、客服采购人员等</p>

              <h4 class="p-t-20">版本2.0.7  2020年10月29日</h4>
              <p class="p-t-5">新增：</p>
              <p class="p-t-5">1.合同变更新增订单相关信息</p>
              <p class="p-t-5">2.新增合同模板</p>

              <p class="p-t-20">改进对比版本2.0.6</p>
              <p class="p-t-5">1.列表采购不做产品类型限制</p>
              <p class="p-t-5">2.订单列车支持替换</p>
              <p class="p-t-5">3.优化销售主动发起下刊为下刊申请</p>
              <p class="p-t-5">4.修复采购页面检索问题</p>

            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img v-show="carouseImg1" src="../../assets/platform/运维台1.png"/>
              <img v-show="!carouseImg1" src="../../assets/platform/运维台.png"/>
              <ul class="ivu-carousel-dots ivu-carousel-dots-inside">
                <li :class="carouseImg1? 'ivu-carousel-active':''">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-right: 5px;" @click="carouseImg1=true"></button>
                </li>
                <li :class="carouseImg1? '':'ivu-carousel-active'">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-left: 5px;" @click="carouseImg1=false"></button>
                </li>
              </ul>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class=" text-16">
              <h3 class="p-t-20">运维台</h3>
              <p class="p-t-10">描述：根据投放方案和服务要求，通过时间、站点、媒介、人员的任务式痕迹化管理，实现从订单到监播的闭环流程，为运营单位提供作业现场闭环式痕迹化的售后服务管理。</p>
              <p class="p-t-5">功能：作业令管理、任务池管理、工单派发、效率分析、任务优化、作业反馈、上刊任务、清洁任务、监播任务、维修任务等；</p>
              <p class="p-t-5">权限：客服人员、施工人员等</p>

              <h4 class="p-t-20">版本2.0.7  2020年10月29日</h4>
              <p class="p-t-5">新增：</p>
              <p class="p-t-5">1.客服主动派发下刊为画面填充</p>
              <p class="p-t-5">2.工单界面新增上刊点位对应合同备注信息</p>
              <p class="p-t-5">3.新增任务界面支撑按客户品牌检索任务</p>

              <p class="p-t-20">改进：对比版本2.0.6</p>
              <p class="p-t-5">1.运维任务列表上刊需求修改为上刊申请</p>
              <p class="p-t-5">2.修复任务统计数据不一致bug</p>
              <p class="p-t-5">3.优化配置供应商及设置画面来源操作</p>

            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img v-show="carouseImg1" src="../../assets/platform/结算台1.png"/>
              <img v-show="!carouseImg1" src="../../assets/platform/结算台.png"/>
              <ul class="ivu-carousel-dots ivu-carousel-dots-inside">
                <li :class="carouseImg1? 'ivu-carousel-active':''">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-right: 5px;" @click="carouseImg1=true"></button>
                </li>
                <li :class="carouseImg1? '':'ivu-carousel-active'">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-left: 5px;" @click="carouseImg1=false"></button>
                </li>
              </ul>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class="text-16">
              <h3 class="p-t-20">结算台</h3>
              <p class="p-t-10">描述：通过录入合同回款及开票信息，完成合同履行的闭环；根据回款信息分析应收账款及账龄；通过初期设置关键指标，系统自动生成渠道或销售提成及奖金。</p>
              <p class="p-t-5">功能：合同回款、合同开票、销售提成及奖金、应收账款按天管理、供应商对账等</p>
              <p class="p-t-5">权限：财务人员、总监等</p>

              <h4 class="p-t-20">版本2.0.7  2020年10月29日</h4>
              <p class="p-t-5">新增：</p>
              <p class="p-t-5">1.新增结算单开票</p>
              <p class="p-t-5">2.开票任务列表新增合同编号</p>

              <p class="p-t-20">改进：对比版本2.0.6</p>
              <p class="p-t-5">1.账单明细更新按照客户及品牌的关键字查询</p>

            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img v-show="carouseImg1" src="../../assets/platform/控制台1.png"/>
              <img v-show="!carouseImg1" src="../../assets/platform/控制台.png"/>
              <ul class="ivu-carousel-dots ivu-carousel-dots-inside">
                <li :class="carouseImg1? 'ivu-carousel-active':''">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-right: 5px;" @click="carouseImg1=true"></button>
                </li>
                <li :class="carouseImg1? '':'ivu-carousel-active'">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-left: 5px;" @click="carouseImg1=false"></button>
                </li>
              </ul>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class="text-16">
              <h3 class="p-t-20">控制台</h3>
              <p class="p-t-10">描述：依靠机器学习和可视化技术，通过对运营数据的采集、清洗、标注、挖掘等步骤，通过多维分析，交叉分析，回归分析等方法，帮助管理者掌握当前态势，了解未来趋势，查找异常原因，实施有依据的决策管理。</p>
              <p class="p-t-5">功能：客户行业分析、媒介产品分析、媒体收入能力、渠道销售能力、财务回款能力、资源交易频度、站点销售热度、任务完成程度、资源维护水平等</p>
              <p class="p-t-5">权限：总经理、总监等</p>

              <h4 class="p-t-20">版本2.0.6 2020年10月29日</h4>
              <p class="p-t-5">新增：</p>
              <p class="p-t-5">1.新增应回款对应合同额数据</p>
              <p class="p-t-5">2.新增多代理商数据隔离显示</p>
              <p class="p-t-5">3.新增按站点拆分合同额</p>

              <p class="p-t-20">改进：对比版本2.0.5</p>
              <p class="p-t-5">1.优化数据加载较慢问题</p>
              <p class="p-t-5">2.修复合同页面查看同名合同bug</p>
              <p class="p-t-5">3.优化运维界面查看上刊点位svg图不显示问题</p>

            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img v-show="carouseImg1" src="../../assets/platform/调度台.png"/>
              <img v-show="!carouseImg1" src="../../assets/platform/调度台1.png"/>
              <ul class="ivu-carousel-dots ivu-carousel-dots-inside">
                <li :class="carouseImg1? 'ivu-carousel-active':''">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-right: 5px;" @click="carouseImg1=true"></button>
                </li>
                <li :class="carouseImg1? '':'ivu-carousel-active'">
                  <button type="button" class="radius" style="width:10px; height:10px; margin-left: 5px;" @click="carouseImg1=false"></button>
                </li>
              </ul>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class="text-16">
              <h3 class="p-t-20">调度台</h3>
              <p class="p-t-10">描述：根据工单和服务要求，通过作业令、作业人时、站点交通时间、实时监测上刊，实现实时现场调度以保证作业完成率，实时反馈质检以提高客户满意度</p>
              <p class="p-t-5">功能：作业路径优化、作业区域优化、实时查看上刊情况、作业完成概率预估、作业完成风险报警、实时调度操作面板等</p>
              <p class="p-t-5">权限：调度员、客服人员等</p>

              <h4 class="p-t-20">版本2.0.0  2020年11月23日</h4>
            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img src="../../assets/platform/OOH销售助手.jpg"/>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class="text-16">
              <h3 class="p-t-50">移动端-OOH销售助手</h3>
              <p class="p-t-10">描述：对接媒介库存和投放需求，为广告主提供标准化的媒体方案以及实时为广告主展示方案，管理售后服务要求，个人KPI管理，移动办公。 </p>
              <p class="p-t-5">功能：客户报备、客户管理、方案定制、订单管理、上刊反馈、KPI管理</p>
              <p class="p-t-5">权限：销售人员、客服采购人员等</p>

              <h4 class="p-t-20">版本2.0.6  2020年10月29日</h4>

              <p class="p-t-5">新增：</p>
              <p class="p-t-5">1.小程序支持实时查看库存功能</p>

            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img src="../../assets/platform/媒势通.jpg"/>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }" class="text-16">
              <h3 class="p-t-50">移动端-控制台</h3>
              <p class="p-t-10">描述：依靠机器学习和可视化技术，通过对运营数据的采集、清洗、标注、挖掘等步骤，通过多维分析，交叉分析，回归分析等方法，帮助管理者掌握当前态势，了解未来趋势，查找异常原因，实施有依据的决策管理。</p>
              <p class="p-t-5">功能：客户行业分析、媒介产品分析、媒体收入能力、渠道销售能力、资源交易频度、站点销售热度、任务完成程度、资源维护水平等。 </p>
              <p class="p-t-5">权限：总经理、总监等</p>

              <h4 class="p-t-20">版本2.0.6  2020年10月29日</h4>

              <p class="p-t-20">改进：对比版本2.0.5 </p>
              <p class="p-t-5">1.优化运维界面数据显示排版</p>
              <p class="p-t-5">2.修复合同详情界面数据加载有误问题</p>
              <p class="p-t-5">3.首页瀑布式合同显示的体验优化</p>
            </i-col>
          </Row>
        </CarouselItem>

        <CarouselItem>
          <Row class="second-content">
            <i-col :xs="24" :lg="12">
              <img src="../../assets/platform/风控.jpg"/>
            </i-col>
            <i-col :xs="{ span: 22, offset: 2 }" :lg="{ span: 11, offset: 1 }">
              <h3 class="p-t-50">经营分析</h3>
              <p class="p-t-20">客户分析、媒体分析、财务分析</p>
              <p class="p-t-20 p-b-20">敬请期待…</p>
            </i-col>
          </Row>
        </CarouselItem>
      </Carousel>

      <a name="third"></a>
      <div class="third-content">
        <p class="text-center p-t-50 p-b-50">我们的服务</p>
        <Row class="p-b-50" type="flex" justify="space-around">
          <i-col class="p-b-20" :xs="24" :lg="8">
            <Row>
              <i-col span="6" class="text-center">
                <Icon type="ios-contacts-outline" size="100" />
              </i-col>
              <i-col span="18" class="link-right">
                <h5>基础服务</h5>
                <p class="p-t-10 third-content-remark">我们将分析您公司的业务特点、资源特征，制定符合当地运营环境的实施方案。 保证平台安全稳定运行的完备设备设施和支撑人员，365天7/24远程和驻场技术支持。</p>
              </i-col>
            </Row>
          </i-col>
          <i-col class="p-b-20" :xs="24" :lg="8">
            <Row>
              <i-col span="6" class="text-center">
                <Icon type="ios-bulb-outline" size="100" />
              </i-col>
              <i-col span="18" class="link-right">
                <h5>咨询服务</h5>
                <p class="p-t-10 third-content-remark">提供基于运营态势和大数据的线路价值分析、客流数据增值、媒体资源运营综合评估等咨询服务。</p>
              </i-col>
            </Row>
          </i-col>
          <i-col class="p-b-20" :xs="24" :lg="8">
            <Row>
              <i-col span="6" class="text-center">
                <Icon type="md-trending-up" size="100" />
              </i-col>
              <i-col span="18" class="p-l-20">
                <h5>增值服务</h5>
                <p class="p-t-10 p-r-20 third-content-remark">依托平台数据及专业数据分析系统有效的帮助传统企业进行资源托管运营。</p>
              </i-col>
            </Row>
          </i-col>
        </Row>
      </div>

      <!-- <h1 class="p-t-20 p-b-20 text-center">合作伙伴</!-->
      <!-- <div class="p-t-20 p-b-20">
        <h2 class="text-center">合作伙伴</h2>
      </div> -->
      <!-- <Row class="fourth-content">
        <i-col :xs="24" :md="8">
          <img src="../../assets/imgs/4-1.jpg"/>
        </i-col>
        <i-col :xs="24" :md="8">
          <img src="../../assets/imgs/4-2.jpg"/>
        </i-col>
        <i-col :xs="24" :md="8">
          <img src="../../assets/imgs/4-3.jpg"/>
        </i-col>
      </Row> -->

      <a name="four"></a>
      <!-- <div class="p-t-20 p-b-20"></div> -->
      <!-- <Row>
          <i-col :xs="{ span: 20, offset: 4 }" :lg="{ span: 8, offset: 8 }">
            <h2><span class="title">—</span>用户评价<Button class="m-l-10" @click="showModalMessage">欢迎评价</Button></h2>
            <p>欧孚士户外媒介交易平台，为您的大数据作出符合您公司业务发展需求的判断。</p>
          </i-col>
      </Row>
      <Row class="p-t-50 p-b-50" type="flex" justify="space-around">
        <i-col span="7">
          <Card>
            <h3>某某客户</h3>
            <p class="remark">2019年11月10日 15:22:35</p>
            <div class="link-top p-b-20"></div>
            <p>评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语</p>
          </Card>
        </i-col>
        <i-col span="7">
          <Card>
            <h3>某某客户</h3>
            <p class="remark">2019年11月10日 15:22:35</p>
            <div class="link-top p-b-20"></div>
            <p>评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语</p>
          </Card>
        </i-col>
        <i-col span="7">
          <Card>
            <h3>某某客户</h3>
            <p class="remark">2019年11月10日 15:22:35</p>
            <div class="link-top p-b-20"></div>
            <p>评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语评语</p>
          </Card>
        </i-col>
      </Row> -->
      <a name="five"></a>
      <!-- <h1 class="p-t-20 p-b-20 text-center">关于我们</h1> -->
      <!-- 弹窗联系我们 -->
      <Modal v-model="modalContactUs" title="给我们留言" :footer-hide="true">
          <Form  ref="messageBean" :model="formItem" :rules="ruleInline" :label-width="70" class="p-r-10">
            <FormItem label="联系人" prop="contacter">
                <i-input v-model="formItem.contacter" placeholder="请输入联系人姓名..."></i-input>
            </FormItem>
            <FormItem label="电话" prop="tel">
                <i-input v-model="formItem.tel" placeholder="请输入联系电话..."></i-input>
            </FormItem>
            <FormItem label="留言">
                <i-input v-model="formItem.mark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入您想给我们的消息..."></i-input>
            </FormItem>
            <FormItem>
                <Button type="error" @click="handleSubmitMessage">提交</Button>
                <Button style="margin-left: 8px" @click="modalContactUs=false">取消</Button>
            </FormItem>
        </Form>
      </Modal>
  </div>
</template>

<script>
import { addContactMsg } from '@/api/website'

export default {
  data () {
    return {
      value1: 0,
      value2: 0,
      carouseImg1: true,
      modalContactUs: false,
      formItem: {
        contacter: '',
        tel: '',
        mark: ''
      },
      ruleInline: {
        contacter: [
          { required: true, message: '请填写联系人', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请填写联系方式', trigger: 'blur' }
        ]
      },
      winWidth: 0 // 页面宽带
    }
  },
  created () {
    // window.addEventListener('resize', function () {
    //   if (window.innerWidth) {
    //     this.winWidth = window.innerWidth
    //   } else if ((document.body) && (document.body.clientWidth)) {
    //     this.winWidth = document.body.clientWidth
    //   }
    // })
    this.changeCarouselImg()
  },
  methods: {
    showModalMessage () {
      this.modalContactUs = true
    },
    handleSubmitMessage () {
      this.$refs['messageBean'].validate((valid) => {
        if (valid) {
          addContactMsg(this.formItem).then(res => {
            if (res.errcode === 0) {
              this.$Notice.success({
                title: '操作成功',
                desc: '感谢您的留言， 我们会尽快与您联系！'
              })
            } else {
              this.$Notice.error({
                title: '操作失败',
                desc: '抱歉，发生一个异常问题， 我们正在全力修复中！'
              })
            }
            this.modalContactUs = false
          })
        }
      })
    },
    changeCarouselImg () {
      setTimeout(() => {
        this.carouseImg1 = !this.carouseImg1
        this.changeCarouselImg()
      }, 5000)
    }
  }
}
</script>
